export default {"src":"/_next/static/media/darkModeNew.e23d813d.svg","height":20,"width":20};